import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "bemutatkozas", label: "Bemutatkozás" },
  { id: "szolgaltatasok", label: "Szolgáltatások" },
  { id: "foglalas", label: "Foglalás" },
  { id: "galeria", label: "Galéria" },
  { id: "kapcsolat", label: "Kapcsolat" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goto = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAF9F6]/95 border-b border-[#E5E0D8] shadow-[0_4px_24px_rgba(0,0,0,0.06)]"
          : "backdrop-blur-md bg-[#FAF9F6]/80 border-b border-white/30"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-20 md:h-24">
        <button
          data-testid="header-logo"
          onClick={() => goto("hero")}
          className="flex items-center gap-3"
          aria-label="CoworkingVilla főoldal"
        >
          <img src="/images/logo.jpg" alt="Villa Porcelaine" className="h-12 md:h-14 w-auto object-contain" />
          <div className="hidden sm:block leading-tight">
            <div className="font-serif-display text-[22px] md:text-[24px] text-[#1A1A1A] font-medium">CoworkingVilla</div>
            <div className="eyebrow text-[9px]">Villa Porcelaine · Keszthely</div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => goto(n.id)}
              className="text-[13px] tracking-[0.18em] uppercase font-semibold text-[#1A1A1A] hover:text-[#BFA588] transition-colors duration-300"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="header-book-cta"
            onClick={() => goto("foglalas")}
            className="btn-primary"
          >
            Foglalj most
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2"
          aria-label="Menü"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile overlay menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden fixed inset-0 top-20 bg-[#FAF9F6] transition-all duration-500 ${
          open ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div className="flex flex-col p-8 gap-1">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`mobile-nav-${n.id}`}
              onClick={() => goto(n.id)}
              className="text-left font-serif-display text-3xl py-4 border-b border-[#E5E0D8] text-[#1A1A1A]"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="mobile-book-cta"
            onClick={() => goto("foglalas")}
            className="btn-primary mt-8 w-full"
          >
            Foglalj most
          </button>
        </div>
      </div>
    </header>
  );
}
